module.exports = __webpack_public_path__ + "static/media/networkFailed.3166c4b2.svg";